'use strict';

// stylesheet import
import '../scss/main.scss';

// import { createApp } from 'vue';
// import { store } from './store.js';
// import App from './vue/app.vue';
import { IntersectionObserverToggleClass } from './modules/class-intersection-observer-toggleclass.js';
import { IsLegacyIE } from './modules/checking-legacy-ie.js';
import { FindOS } from './modules/checking-os.js';
import { FindBrowser } from './modules/checking-browser.js';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
const $ = require('jQuery');

// Vue.js
// const app = createApp({});
// app.component('app', App)
//   .use(store)
//   .mount('#app');
  
// jQuery
$(function() {

  // drawer navi 
  $('.js-hamburger').on('click', function() {
    $('.js-drawer-navi').toggleClass('__shown').toggleClass('__offcanvas-shown');
    $(this).toggleClass('__close');
    if(0 < $('.js-header-home').length || 0 < $('.js-header-no-bg').length) {
      $('.js-header').toggleClass('__inview');
    }
    // if($(this).hasClass('__close')) {
    //   $(this).removeClass('__inview');
    // } else {
    //   $(this).addClass('__inview');
    // }
    if(window.matchMedia('(max-width: 768px)').matches) {
      $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
      if(0 < $('.js-header-home').length || 0 < $('.js-header-no-bg').length) {
        $(this).removeClass('__inview');
        $('.js-header').removeClass('__inview');
        $('.js-hamburger').removeClass('__inview');
      }
    } else {
      if(100 < window.scrollY) {
        $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
        if(0 < $('.js-header-home').length || 0 < $('.js-header-no-bg').length) {
          $('.js-header').removeClass('__inview');
          $('.js-hamburger').removeClass('__inview');
          $(this).removeClass('__inview');
        }
      } else {
        if($(this).hasClass('__close')) {
          $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
          if(0 < $('.js-header-home').length || 0 < $('.js-header-no-bg').length) {
            $(this).removeClass('__inview');
            $('.js-header').removeClass('__inview');
            $('.js-hamburger').removeClass('__inview');
            $(this).removeClass('__inview');
          }
        } else {
          if(0 < $('.js-header-home').length) {
            $('.js-header').addClass('__inview');
            $('.js-hamburger').addClass('__inview');
            $(this).addClass('__inview');
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_white.svg');
          } else {
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
          }
        }
      }
    }
  });
  $(window).on('scroll', function() {
    $('.js-drawer-navi').removeClass('__shown').removeClass('__offcanvas-shown');
    $('.js-hamburger').removeClass('__close');
  });

  // header effect
  if(0 < $('.js-header-home').length || 0 < $('.js-header-no-bg').length) {
    if(window.matchMedia('(max-width: 768px)').matches) {
      $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
    } else {
      if(0 < $('.js-header-home').length)  {
        $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_white.svg');  
      } else {
        $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');  
      }
      
    }
    $(window).on('resize', function() {
      if(window.matchMedia('(max-width: 768px)').matches) {
        $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
      } else {
        if(100 < window.scrollY || $('.js-hamburger').hasClass('__close')) {
          $('.js-header').removeClass('__inview');
          $('.js-hamburger').removeClass('__inview');
          $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
        } else {
          $('.js-header').addClass('__inview');
          $('.js-hamburger').addClass('__inview');
          if(0 < $('.js-header-home').length)  {
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_white.svg');
          } else {
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
          }
          
        }
      }
    });
    $(window).on('scroll load', function() {
      if(window.matchMedia('(max-width: 768px)').matches) {
        $('.js-header').removeClass('__inview');
        $('.js-hamburger').removeClass('__inview');
        $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
      } else {
        if(100 < window.scrollY || $('.js-hamburger').hasClass('__close')) {
          $('.js-header').removeClass('__inview');
          $('.js-hamburger').removeClass('__inview');
          $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
        } else {
          $('.js-header').addClass('__inview');
          $('.js-hamburger').addClass('__inview');
          if(0 < $('.js-header-home').length)  {
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_white.svg');
          } else {
            $('.js-header-logo').attr('src', './assets/images/site/common/common_logo_color.svg');
          }
        }
      }
    });
  }
  

  // dialog
  $('.js-dialog-button-internship').on('click', function() {
    $('.js-dialog-entry').slideUp();
    $('.js-dialog-internship').slideToggle();
  });
  $('.js-dialog-button-entry').on('click', function() {
    $('.js-dialog-internship').slideUp();
    $('.js-dialog-entry').slideToggle();
  });
  $(window).on('scroll', function() {
    $('.js-dialog-entry').slideUp();
    $('.js-dialog-internship').slideUp();
    $('.js-dialog--entry--footer').hide();
  });

  // scroll top 
  $(window).on('scroll', function() {
    if(3400 < window.scrollY) {
      $('.js-scroll-top').fadeIn()
    } else {
      $('.js-scroll-top').fadeOut()
    }
  });
  $('.js-scroll-top-button').on('click', function() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  });

  // modal 
  $('.js-modal-close').on('click', function() {
    $('.js-modal-dialog').hide();
  });
  $(window).on('resize', function() {
    $('.js-modal-dialog').hide();
    if(window.matchMedia('(max-width: 768px)').matches) {
      $('.js-dialog--entry--footer').hide();
    }
  });
  $('.js-entry-dialog-footer').on('click', function() {
    if(window.matchMedia('(max-width: 768px)').matches) {
      $('.js-modal-dialog').show();
    } else{
      $('.js-dialog--entry--footer').toggle();
    }
  });

});

// Intersection Observer
new IntersectionObserverToggleClass({
  selector: '.observe_target', 
  className: 'observed', 
  toggle: true
});

// checking legacy IE
IsLegacyIE();

// checking OS
FindOS();

// checking browser
FindBrowser();

// youtube modal 
const modalOpenButton = document.querySelector('.js-movie-modal-open');
const modalCloseButton = document.querySelector('.js-movie-modal-close');
const modalMovie = document.querySelector('.js-movie-modal');
const videoIframe = document.querySelector('.js-movie-iframe');
const onYouTubeIframeAPIReady = () => {
  window.YT.ready(() => {
    const movieId = videoIframe.getAttribute('id');
    const player = new YT.Player(movieId, {
      videoId: movieId,
      playerVars: {
        loop: 0,
        rel: 0
      }
    });
    modalOpenButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      modalMovie.classList.add('__shown');
      const id = modalOpenButton.hash.replace('#', '');
      document.getElementById(player.getVideoData().video_id).style.display = 'block';
      player.unMute().playVideo();
    });
    modalCloseButton.addEventListener('click', (event) => {
      player.stopVideo();
      document.getElementById(player.getVideoData().video_id).style.display = 'none';
      modalMovie.classList.remove('__shown');
    });
  });
}
if(videoIframe) {
  onYouTubeIframeAPIReady();
}

// swiper
const swiper = new Swiper('.swiper', {
  loop: true,
  slidesPerView: 1.5,
  spaceBetween: 25,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
    },
    992: {
      slidesPerView: 3.5,
    },
    1280: {
      slidesPerView: 4.5,
    }
  }
});

// GSAP
gsap.registerPlugin(ScrollTrigger);

// scroll fadein
const scrollAnimationItems = gsap.utils.toArray('.js-scroll-animation-fadein--element');
scrollAnimationItems.forEach((item) => {
  gsap.fromTo(
    item,
    {
      y: 64,
      autoAlpha: 0
    },
    {
      y: 0,
      autoAlpha: 1,
      delay: 0.1,
      duration: 1.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: item,
        start: 'top 70%',
        end: 'bottom 60%',
        // markers: true
      },
      stagger: {
        from: 'start',
        amount: 1.8
      }
    }
  );
});

// graph animation
gsap.timeline({
  delay: 0.1,
  repeat: 0,
  scrollTrigger: {
    trigger: '.js-graph-animation--trigger',
    start: 'top 70%',
    end: 'bottom 60%',
    // markers: true
  },
  
}).fromTo(
  '.js-graph-animation--element-bar',
  {
    scaleY: 0,
  },
  {
    scaleY: 1,
    duration: 1.2,
    ease: 'power2.out',
    stagger: {
      from: 'start',
      amount: 1.4
    }
  }
).fromTo(
  '.js-graph-animation--element-text',
  {
    y: 48,
    autoAlpha: 0
  },
  {
    y: 0,
    autoAlpha: 1,
    duration: 1.2,
    ease: 'power2.out',
    stagger: {
      from: 'start',
      amount: 1.4
    }
  }
).fromTo(
  '.js-graph-animation--element-arrow',
  {
    y: 48,
    autoAlpha: 0
  },
  {
    y: 0,
    autoAlpha: 1,
    duration: 1.2,
    ease: 'power2.out',
  }
).fromTo(
  '.js-graph-animation--element-man',
  {
    y: 48,
    autoAlpha: 0
  },
  {
    y: 0,
    autoAlpha: 1,
    duration: 1.2,
    ease: 'power2.out',
  }
);

// home typography
ScrollTrigger.batch('.js-typography-animation--element', {
  batchMax: 40,
  onEnter: batch => gsap.fromTo(batch,
    {
      transform: 'translate(0, 120px) rotate3d(-1, -1, -1, 180deg)',
      opacity: 0,
      visibility: 'hidden'
    },
    { 
      transform: 'translate(0, 0) rotate3d(1, 1, 1, 0deg)',
      opacity: 0.6,
      visibility: 'visible',
      delay: 0.1,
      duration: 1.2,
      ease: 'expo.out',
      scrollTrigger: {
        start: 'top 70%',
        end: 'bottom 60%',
        // markers: true
      },
      stagger: {
        from: 'start',
        amount: 0.8
      }
    }
  ),
  once: true
});

// counter animation
const counterAnimation = (number, element) => {
  const counter = setInterval(() => {
    element.innerText = Math.floor(Math.random() * 10)
  }, 10);
  const complate = () => {
    element.innerText = number;
  }
  setTimeout(() => {
    clearInterval(counter);
    complate();
  }, 1000);
};
const counterAnimationItems = gsap.utils.toArray('.js-counter-animation--element');
counterAnimationItems.forEach((element) => {
  const defaultValue = element.getAttribute('data-number');
  gsap.fromTo(
    element,
    {
      autoAlpha: 0
    },
    {
      autoAlpha: 1,
      delay: 0.1,
      duration: 0.1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: element,
        start: 'top 70%',
        end: 'bottom 60%',
        // markers: true
      },
      onEnter: () => {
        counterAnimation(defaultValue, element);
      }
    }
  );
});


